import { Checkbox, Col, Row, Space } from 'antd';

import { Container, MilesText, TitledContainer } from 'components';

import { featureFlagStore, toggleFeatureFlag } from 'stores';

export const FeatureFlag = () => {
  const featureFlags = featureFlagStore((state) => state.featureFlags);

  return (
    <TitledContainer title='Feature Flag'>
      <Container className='flex-none'>
        <Space direction='vertical' size={16}>
          {featureFlags.map((featureFlag) => (
            <Row key={featureFlag.name}>
              <Col xs={24}>
                <Checkbox
                  checked={featureFlag.enabled}
                  onChange={() => toggleFeatureFlag({ name: featureFlag.name })}
                >
                  <MilesText>
                    {featureFlag.name}
                  </MilesText>
                </Checkbox>
              </Col>

              <Col xs={24}>
                <MilesText>
                  {featureFlag.description}
                </MilesText>
              </Col>
            </Row>
          ))}
        </Space>
      </Container>
    </TitledContainer>
  );
};
